// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EbtaG","field":"styles_field__K7Dwx","fieldCol":"styles_fieldCol__2wRpy","diffCol":"styles_diffCol__GwZJC","diff":"styles_diff__3jETo"};